module.exports = __webpack_public_path__ + "static/eric-resendiz-social-abeb7596499b1aac694cc1128c295a3a.jpg";